<template>
   <div style="margin:5px" class="grey lighten-5">

                  <v-toolbar color="grey lighten-2">

             <v-row>
                    <v-col  cols="12" md="4">

<v-btn text  @click="$router.push('/sumarios-publicados')"><v-icon large color="primary" >clear</v-icon></v-btn>

    </v-col>

     <v-col cols="12" md="7">  <!--  form titlte section   {{ formTitle }}-->
     </v-col>

      <v-col  cols="12" md="1">
     <v-btn   :disabled="!valid"    color="primary" text  @click="submitFiles()"><v-icon large color="primary" >send</v-icon></v-btn>
   </v-col>
  </v-row>
                  </v-toolbar>
  <div  v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>
      <v-row>
<v-col class="d-flex" cols="12" >
            <v-progress-linear v-if="progress"
            color="green"
            indeterminate
            rounded
            height="3"
          ></v-progress-linear>
        </v-col>
        <v-row
          class="pa-4"
          align="center"
          justify="center"
        >
        </v-row>
      </v-row>

    <v-form  style="margin:5px"
     ref="form"
      v-model="valid"
      lazy-validation>

        <v-row >

          <v-col
            cols="12"
            md="2"

          >
            <v-select
              v-model="editedItem.controldisciplina"
              item-value="controliddisciplina"
              item-text="disciplina"
              @change="anoAcademico()"
              :items="disciplinas"
              :disabled="isUpdating"
              filled
              color="blue-grey lighten-2"
              label="Disciplina"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            md="3"

          >

            <v-select
              v-model="editedItem.anoacademico"
              :rules="ruleRequiredClasse"
              item-value="anoacademico"
              item-text="classe"
               @change="loadUnidadeComb"
              :items="anoAcademicoAll"
              :disabled="isUpdating"
              filled
              color="blue-grey lighten-2"
              label="Classe"
            ></v-select>
          </v-col>

          <v-col
            cols="12"
              md="2"

          >

    <v-combobox
      v-model=" editedItem.unidade"
      :rules="ruleTextRequired"
      item-value="pkUnidade"
      item-text="descricao"
      @click="limparAbaixoUnidade()"
      @change="loadSumarioComb"
      :items="unidades"
      label="Unidade"
       color="blue-grey lighten-2"
       filled
      multiple
      persistent-hint
      small-chips
    >

    </v-combobox>

          </v-col>
          <v-col cols="12" md="3">
    <v-combobox
      v-model="editedItem.sumario"
      :rules="ruleTextRequired"
      item-value="pkSumario"
      item-text="descricao"
      @change="loadAulaComb"
      :items="sumarios"
      label="Súmario"
       color="blue-grey lighten-2"
       filled
      multiple
      persistent-hint
      small-chips>
    </v-combobox>
          </v-col>
          <v-col cols="12" md="2" >
    <v-select
      v-model="editedItem.aula"
      :rules="ruleRequiredClasse"
      item-value="descricao"
      item-text="descricao"
      @change="filterConteudo ()"
      :items="licaoFiltered"
      label="Aula"
      :disabled="isUpdating"
      filled
    color="blue-grey lighten-2" >
    </v-select>
          </v-col>
          <div class="container">
          <div class="large-12 medium-12 small-12 cell">
      <label>Adicionar anexo
        <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()"/>
      </label>
      <button v-on:click="addFiles()"><v-icon large color="primary" >link</v-icon></button>
    </div>
    <br>
    <div class="large-12 medium-12 small-12 cell">
      <div v-for="(file, key) in files" class="file-listing">{{ file.name }}<span class="remove-file" v-on:click="removeFile( key )"><v-icon small >delete</v-icon></span></div>
    </div>
    <br>
    </div>
          <v-container >
        <v-row>
        <v-col cols=12 >
    <div id="app">
        <ckeditor  :editor="editor" v-model="editorData" :config="editorConfig" ></ckeditor>
    </div>
     </v-col>
    </v-row>
    </v-container>
   </v-row>
    </v-form>
   <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
         :disabled="!valid"
        :loading="isUpdating"
        depressed
        @click="submitFiles()">
       <v-icon large color="primary" >send</v-icon></v-btn>

    </v-card-actions>
    <v-divider></v-divider>

      </div>

</template>

<script>
import axios from '../../plugins/axios'
// const fs = require('fs')
// const request = require('request')
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
import Table from '@ckeditor/ckeditor5-table/src/table'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'
import TableProperties from '@ckeditor/ckeditor5-table/src/tableproperties'
import TableCellProperties from '@ckeditor/ckeditor5-table/src/tablecellproperties'
import Font from '@ckeditor/ckeditor5-font/src/font'
var FormData = require('form-data')
const ls = require('local-storage')

export default {
  name: 'app',
  data () {
    return {
      files: [],
      progress: false,
      editor: ClassicEditor,
      valor: {
        controliddisciplina: 0,
        disciplinaDescricao: '',
        idProfessor: '',
        unidadeDescricao: '',
        idUnidade: 0,
        sumarioDescricao: '',
        autor: '',
        idSumario: 0,
        idAula: 0,
        aulaDescricao: '',
        anoacademico: 0,
        classe: '',
        conteudo: ''
      },
      editorData: this.$store.state.editorData,
      editorConfig: {
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin,
          Alignment,
          Image,
          Table,
          TableToolbar,
          TableProperties,
          TableCellProperties,
          Font
        ],

        toolbar: {
          items: [
            'bold',
            'italic',
            'link',
            'undo',
            'redo',
            'alignment',
            'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells',
            'tableProperties', 'tableCellProperties',
            'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor',
            'imageResize', 'imageUpload', 'imageInsert', 'imageTextAlternative', '|', 'imageStyle:full', 'imageStyle:side'
          ]
        }
      },
      licao: [
        {
          descricao: '01'
        },
        {
          descricao: '02'
        },
        {
          descricao: '03'
        },
        {
          descricao: '04'
        },
        {
          descricao: '05'
        }
      ],
      ruleRequiredClasse: [value => !!value || 'campo obrigatorio'],
      ruleTextRequired: [
        value => !!value || 'campo obrigatório.',
        value => {
          const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
          return !pattern.test(value) || 'Invalido.'
        }
      ],
      insertSumario: [],
      isUpdating: false,
      disciplinas: [],
      unidades: [],
      sumarios: [],
      aulas: [],
      licaoFiltered: [],
      anoAcademicoAll: [],
      valid: true,
      dataIsCreated: false,
      unidadesFiltered: [],
      sumariosFiltered: [],
      aulasFiltered: [],
      loadcombAula: null,
      loadcombUnidade: null,
      loadcombSumario: null,
      formValid: true,
      editedItem: {
        classe: '',
        controldisciplina: null,
        disciplina: '',
        pkUnidade: 0,
        pkSumario: 0,
        pkAula: 0,
        unidade: null,
        sumario: null,
        aula: null,
        anoacademico: 0,
        conteudo: ''
      },
      defaultItem: {
        disciplina: '',
        pkUnidade: 0,
        pkSumario: 0,
        pkAula: 0,
        unidade: null,
        sumario: null,
        aula: null,
        anoacademico: 0,
        conteudo: ''
      },

      date: '15-04-2020'
    }
  },

  watch: {

    isUpdating (val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000)
      }
    }
  },
  created () {
    this.initializeDisciplinaProf()
  },
  methods: {
    /**
     * Anexando Documentos
     */
    addFiles () {
      this.$refs.files.click()
    },
    async submitFiles () {
      if (this.files.length < 5 && this.$refs.form.validate() && (this.editedItem.unidade && this.editedItem.sumario && this.editedItem.aula) && !this.dataIsCreated) { // Verificar se o formulario foi preenchido correctamente
        this.valor = [{
          controliddisciplina: this.editedItem.controldisciplina,
          disciplinaDescricao: this.anoAcademicoAll[0].disciplina,
          idProfessor: ls.get('idPessoa'),
          unidadeDescricao: this.loadcombUnidade.descricao,
          idUnidade: this.loadcombUnidade.pkUnidade,
          sumarioDescricao: this.loadcombSumario.descricao,
          autor: ls.get('nomeUsuario'),
          idSumario: this.loadcombSumario.pkSumario,
          idAula: this.loadcombAula.pkAula,
          aulaDescricao: this.loadcombAula.descricao,
          anoacademico: this.editedItem.anoacademico,
          classe: this.editedItem.classe,
          conteudo: this.editorData
        }]
        this.progress = true
        let formData = new FormData()

        /*
          Iteate over any file sent over appending the files
          to the form data.
        */
        formData.append('aulas', JSON.stringify(this.valor)) // this must always come first ahaed of loop
        for (var i = 0; i < this.files.length; i++) {
          let file = this.files[i]

          formData.append('files[' + i + ']', file)
        }

        // formData.append('first_name', 'Dan')

        axios.post('/upload-files', formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(function (response) {
        })
          .catch(function (error) {
            console.log('error' + error)
            console.log('errorData' + error.data)
          })
        this.progress = false
      }
    },

    /*
        Handles the uploading of files
      */
    handleFilesUpload () {
      let uploadedFiles = this.$refs.files.files
      if (this.$refs.files.files.length > 0) this.valid = true
      /*
          Adds the uploaded file to the files array
        */
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i])
      }
    },

    /*
        Removes a select file the user has uploaded
      */
    removeFile (key) {
      this.files.splice(key, 1)
    },
    /** */
    limparAbaixoUnidade () {
      this.editedItem.sumario = null
      this.editedItem.aula = null
    },
    validate () {
      if (this.$refs.form.validate()) {
        return true
      } else {
        return false
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    async loadUnidadeComb () {
      this.classe()
      this.editedItem.unidade = null
      this.limparAbaixoUnidade()
      this.editorData = this.addSumario()
      const discAnoAcademico = [{ anoacademico: this.editedItem.anoacademico, controliddisciplina: this.editedItem.controldisciplina }]
      if (parseInt(this.editedItem.controldisciplina) > 0) {
        this.isLoading = true
        try {
          this.isUpdating = true
          this.unidades = await axios
            .post('/unidadefindAll', discAnoAcademico)
            .then(res => res.data)
          this.isUpdating = false
        } catch (error) {
          this.isUpdating = false
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        } this.isLoading = false
      }
    },
    async  loadSumarioComb () {
      if (this.editedItem.unidade) {
        this.loadcombUnidade = { pkUnidade: 0, descricao: this.editedItem.unidade }
        if (this.editedItem.unidade.length > 0 && this.editedItem.unidade[0].pkUnidade > 0) {
          this.isLoading = true
          try {
            this.isUpdating = true
            this.sumarios = await axios
              .get('/sumariofindAll/' + this.editedItem.unidade[0].pkUnidade)
              .then(res => res.data)

            this.isUpdating = false
          } catch (error) {
            this.isUpdating = false
            this.text = error
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
          } this.isLoading = false
          this.loadcombUnidade = { pkUnidade: this.editedItem.unidade[0].pkUnidade, descricao: this.editedItem.unidade[0].descricao }
        }
      }
    },
    async loadAulaComb () {
      if (this.editedItem.sumario) {
        this.loadcombSumario = { pkSumario: 0, descricao: this.editedItem.sumario }

        if (this.editedItem.sumario.length > 0 && this.editedItem.sumario[0].pkSumario > 0) {
          this.isLoading = true
          try {
            this.isUpdating = true
            this.aulas = await axios
              .get('/aulafindAll/' + this.editedItem.sumario[0].pkSumario)
              .then(res => res.data)
            this.isUpdating = false
          } catch (error) {
            this.isUpdating = false
            this.text = error
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
          } this.isLoading = false
          this.loadcombSumario = { pkSumario: this.editedItem.sumario[0].pkSumario, descricao: this.editedItem.sumario[0].descricao }
        } this.filterLicao()
      }
    },
    filterConteudo () {
      // Objecto aula com o seu valor inserido na combo
      this.loadcombAula = { pkAula: 0, descricao: this.editedItem.aula }
      // Objecto aula com o seu valor selecionado na combo
      if (this.editedItem.aula.length > 0 && this.editedItem.aula[0].pkAula > 0) {
        this.loadcombAula = { pkAula: this.editedItem.aula[0].pkAula, descricao: this.editedItem.aula[0].descricao }
        // Conteudo da aula filtrada
        this.editorData = (this.aulas.filter(t => t.pkAula === this.loadcombAula.pkAula))[0].conteudo
        this.dataIsCreated = true
      }
    },

    async  anoAcademico () {
      this.anoAcademicoAll = this.disciplinas.filter(t => t.controliddisciplina === this.editedItem.controldisciplina)
    },
    async  classe () {
      if (this.editedItem.anoacademico === 1) this.editedItem.classe = '10ªClasse'
      else
      if (this.editedItem.anoacademico === 2) this.editedItem.classe = '11ªClasse'
      else
      if (this.editedItem.anoacademico === 3) this.editedItem.classe = '12ªClasse'
      else
      if (this.editedItem.anoacademico === 4) this.editedItem.classe = '13ªClasse'
    },
    async initializeDisciplinaProf () {
      try {
        this.isUpdating = true
        this.isLoading = true
        this.disciplinas = await axios
          .get('/findDisciplinaInProfDiscAll/' + ls.get('idPessoa'))
          .then(res => res.data)
        this.isUpdating = false
      } catch (error) {
        this.isUpdating = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } this.isLoading = false
    },

    // Inserir Súmario

    async insertProfSumario () {
      if (this.$refs.form.validate() && (this.editedItem.unidade && this.editedItem.sumario && this.editedItem.aula) && !this.dataIsCreated) { // Verificar se o formulario foi preenchido correctamente
        const valor = [{
          controliddisciplina: this.editedItem.controldisciplina,
          idProfessor: ls.get('idPessoa'),
          unidadeDescricao: this.loadcombUnidade.descricao,
          idUnidade: this.loadcombUnidade.pkUnidade,
          sumarioDescricao: this.loadcombSumario.descricao,
          autor: ls.get('nomeUsuario'),
          idSumario: this.loadcombSumario.pkSumario,
          idAula: this.loadcombAula.pkAula,
          aulaDescricao: this.loadcombAula.descricao,
          anoacademico: this.editedItem.anoacademico,
          conteudo: this.editorData
        }]
        this.dataIsCreated = false
        /**   try {
          this.insertSumario = await axios
            .post('/insertSumario', valor)
            .then(res => res.data)
          // Menssagem de sucesso da operação
          this.$store.dispatch('textMessage', { 'msg': 'Operação feita com sucesso', 'classMessage': 'msgSucess', 'timeout': 2000 })
          this.isUpdating = false

          this.close()
        } catch (error) {
          this.isLoading = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        } this.isLoading = false
        this.isLoading = true */
        this.limparCampos()
      } else {
        alert('Preencha Devidamente os campos, Apenas é permitido adicionar súmario')
        this.limparCampos()
      }
    },
    limparCampos () {
      this.editedItem.unidade = null
      this.editedItem.sumario = null
      this.editedItem.aula = null
      this.editedItem.anoacademico = null
      this.editedItem.controldisciplina = null
      this.$refs.form.resetValidation()
      this.editorData = this.$store.state.editorData
      this.anoAcademicoAll = []
    },

    filterLicao () {
      this.licaoFiltered = this.licao
      for (let index = 0; index < this.aulas.length; index++) {
        this.licaoFiltered = this.licaoFiltered.filter(t => t.descricao !== this.aulas[index].descricao)
      }
    },

    addSumario () {
      return ` 
    <style>
    table {
        display: table;
        border-collapse: separate;
        box-sizing: border-box;
        border-spacing: 2px;
        border-color:blue   ;
        border:1px;
    }
    </style>
    
    <h1>Plano de aula</h1>
    
    
    <table >
      
      <tr>
       <td>
          <strong>Professor(a): </strong>
        ` + ls.get('nomeUsuario') + ` <p/> 
       
        <strong> Disciplina: </strong>
        ` + this.anoAcademicoAll[0].disciplina + ` <p/>
         <strong>Classe: </strong> 
          ` + this.editedItem.classe + `  
     </td>
        
      </tr>
      <tr>
        <td>
        
        <strong> Tema: </strong>
    O tema específico a ser desenvolvido nesta aula   
        </td>
        
      </tr>
      <tr>
        <td>
        
        <strong>
      OBJECTIVOS:</strong>
     a serem alcançados pelos alunos e não peloestagiário/professor;<p>
    <strong>Objectivo geral
    :</strong> projecta resultados relativos a execução de conteúdos e procedimentos.<p>
    <strong>Objectivos específicos</strong>
    :</strong> especificam resultados esperados e observáveis(geralmente de 3 a 4)
    
       </td>
        
      </tr>
      <tr>
        <td>
        
        <strong>
      Conteúdo:</strong>
     conteúdos programados para a aula organizados em tópicos (de 4ª8)
      
      </td>
        
      </tr>
       <tr>
        <td>
        
        <strong>
      Desenvolvimento do tema
    :</strong> descrição da abordagem teórica e pratica do tema(em anexo)VII.
      </td>
        
      </tr>
      <tr>
        <td>
        
        <strong>
    Recursos didácticos:</strong>
     (quadro, giz, retro-projector, etc.) e fontes histórico-escolares (Filme, musica, quadrinhos, etc)VIII.
     
      </td>
        
      </tr>
      <tr>
        <td>
        
        <strong>
    Observação ou avaliação:</strong>
     pode ser realizada com diferentes propósitos(diagnostica, formativa e somátiva). Discriminar, com base nos objectivos estabelecidos para aula:<p>
    <strong>Actividades</strong>
     (ex: respostas às perguntas - problema ao final da aula, discussãodo roteiro, compreensão de gravuras, trabalho com documentos, etc.Critérios adoptados para a correcção da actividade.IX.
     
      </td>
        
      </tr>
     
      <tr>
        <td>
        
        <strong>
    Bibliografia:</strong> indicar toda a bibliografia consultada para o planeamento da aula dividindo-a entre básica e complementar.
    
      </td>
        
      </tr>
    </table>

      
              `
    }
  }

}

</script>
<style  >
.search {
  display: flex;
  flex-wrap: wrap;
  background-color: rgba(170, 169, 162, 0.5);
  padding: 0.5rem;
  border-radius: 5px;
  margin: 1rem 0;
}
input {
    padding: 0.25rem;
    border: 0;
    border-radius: 3px;
    margin-right: 0.2rem;
    font: inherit;
    font-size: 0.8rem;
    width: 20%;
    flex: 1;
  }

  .find {
  background: rgba(255, 213, 0, 0.5);
}

.editor-box> * {
    border-color:red;
    border-width: 1px;
    background-color:beige
;
}

.is-active{
    border-color: grey;
    border-style: solid;
    border-width: 1px;
}
 input[type="file"]{
    position: absolute;
    top: -500px;
  }

  div.file-listing{
    width: 200px;
  }

  span.remove-file{
    color: red;
    cursor: pointer;
    float: right;
  }
/**     */

</style>
